export default __webpack_public_path__ + "static/media/ThinBannerForCTEDashboard.fc40f261.svg";